import { render, staticRenderFns } from "./tablaenreparacion.vue?vue&type=template&id=d9afa976&scoped=true"
import script from "./tablaenreparacion.vue?vue&type=script&lang=js"
export * from "./tablaenreparacion.vue?vue&type=script&lang=js"
import style0 from "./tablaenreparacion.vue?vue&type=style&index=0&id=d9afa976&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9afa976",
  null
  
)

export default component.exports